{
  "title": "VIP Cashback",
  "yourLevel": "SIZNING DARAJANGIZ",
  "completed": "YAKUNLANDI",
  "locked": "YOPIQ",
  "xpLabel": "Tajriba",
  "xpRule": "Tajriba hisobi: €1 tikish = {{xp}} tajriba balli",
  "cashback": "Keshbek {{pct}}%",
  "cashbackMax": "Keshbek {{lo}}% - {{hi}}%",
  "daily": "Har kuni",
  "everyDays": "{{days}} kunda bir marta",
  "active": "Faol: AZN {{amount}}",
  "claim": "OLISH",
  "howTitle": "Bu qanday ishlaydi?",
  "how1": "Sevimli slot va o‘yinlaringizni o‘ynang",
  "how2": "Tajriba yig‘ing va darajangizni oshiring",
  "how3": "Keshbek va mukofotlar oling",
  "lockedNote": "«{{name}}» darajasiga yetish uchun ko‘proq tajriba kerak",
  "loginHint": "XP, keshbek va olish uchun kiring",
  "login": "Kirish",
  "history": "Tarix",
  "historyEmpty": "Hali yozuv yo‘q.",
  "claimTitle": "Keshbek olish",
  "claimAmount": "Summa: {{amount}} AZN",
  "claimNote": "To‘g‘ridan-to‘g‘ri real balansga. Wagering: 0x.",
  "cancel": "Bekor",
  "confirm": "Tasdiqlash",
  "congrats": "Tabriklaymiz!",
  "newLevel": "Yangi VIP daraja: {{name}}",
  "continue": "Davom etish",
  "infoBody": "Faqat real pul kazino tikishlari XP va keshbek beradi. Bonus, sport va demo kirmaydi. 24 soat kutish va min 1 AZN.",
  "close": "Yopish",
  "maxNote": "VIP MAX — XP to‘xtaydi. Kategoriya aylanmasi keshbeki.",
  "level_1": "Mis",
  "level_2": "Bronza",
  "level_3": "Kumush",
  "level_4": "Oltin",
  "level_5": "Yoqut",
  "level_6": "Safir",
  "level_7": "Olmos",
  "level_8": "VIP MAX",
  "maintenance": "Texnik tanaffus — olish vaqtincha yopiq.",
  "rulesTitle": "QAYDALAR",
  "rulesIntro": "“VIP Cashback” Kazinosuna xoş gəlmisiniz! Sistem səviyyənizə, oyun növlərinə və mərc müntəzəmliyinə görə real pulun bir hissəsini geri almaq imkanı verir. Nə qədər aktiv oynasanız, bir o qədər tez-tez və daha çox keşbek əldə edirsiniz.",
  "rulesWhatTitle": "VIP Cashback nədir",
  "rulesWhat": "Keşbek — oyun aktivliyinə görə xərclənmiş vəsaitin bir hissəsinin geri qaytarılmasıdır. Dinamikdir və səviyyəniz yüksəldikcə dəyişir.",
  "rulesLevelsTitle": "Cashback səviyyələri",
  "rulesLevels1": "Sistemdə 8 səviyyə var. Növbəti səviyyəyə keçmək üçün təcrübə xalı toplamaq lazımdır.",
  "rulesLevels2": "Yeni səviyyə keşbek faizini və götürmə tezliyini artırır.",
  "rulesXpTitle": "Təcrübə xalının hesablanması",
  "rulesXpNote": "Hər səviyyədə €1 mərc = müvafiq XP. Saytda balans və keşbek AZN-dir; XP əmsalları eyni qaydada tətbiq olunur (1 AZN mərc = eyni XP).",
  "rulesCbTitle": "Cashback necə işləyir",
  "rulesCb1": "1–7 səviyyələrdə (Mis–Almaz) keşbek uduzulmuş mərclərə görə hesablanır.",
  "rulesCbFormula": "Keşbek = (Mərclərin cəmi − Qazanılan məbləğ) × keşbek %",
  "rulesCb2": "Dövr üzrə nəticə müsbətdirsə, keşbek 0 olur.",
  "rulesCb3": "VIP MAX-da keşbek hər real mərcə görə kateqoriya faizi ilə verilir: Slot 0.25%, Lotereya 0.20%, Canlı kazino 0.10%, Masa oyunları 0.05%.",
  "rulesImportantTitle": "Bilmək vacibdir",
  "rulesImportant1": "Bonus balanslı, idman və demo mərclər XP/keşbek yaratmır.",
  "rulesImportant2": "24 saat gözləmə və minimum 1 AZN götürmə qaydası qüvvədədir.",
  "rulesImportant3": "Keşbek birbaşa real balansa köçürülür (0x wagering).",
  "rulesXp1": "1-ci səviyyə “Mis”: Hər €1 mərc üçün oyunçu 100 təcrübə xalı alır",
  "rulesXp2": "2-ci səviyyə “Bürünc”: Hər €1 mərc üçün oyunçu 150 təcrübə xalı alır",
  "rulesXp3": "3-ci səviyyə “Gümüş”: Hər €1 mərc üçün oyunçu 200 təcrübə xalı alır",
  "rulesXp4": "4-ci səviyyə “Qızıl”: Hər €1 mərc üçün oyunçu 250 təcrübə xalı alır",
  "rulesXp5": "5-ci səviyyə “Yaqut”: Hər €1 mərc üçün oyunçu 300 təcrübə xalı alır",
  "rulesXp6": "6-ci səviyyə “Safir”: Hər €1 mərc üçün oyunçu 350 təcrübə xalı alır",
  "rulesXp7": "7-ci səviyyə “Almaz”: Hər €1 mərc üçün oyunçu 400 təcrübə xalı alır",
  "rulesXp8": "8-ci səviyyə “VIP MAX”: sonuncu səviyyə, təcrübə xalı verilmir",
  "lockedShort": "YOPIQ"
}
